module.exports = __webpack_public_path__ + "static/img/photo15.1af71555.jpg";